// extracted by mini-css-extract-plugin
export default {"subtaskCard":"taskFormModal_subtaskCard__lRMYK"};